function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class DesignYourEngagementRing extends HTMLElement {
  constructor() {
    super();
    const sessionParams = this.getDefaultSearchParams();

    this.states = {
      results: false,
      errors: false,
      loading: false,
    };
    //this.apiUrl = 'https://regal-nivoda-apis-579ac5fd47d5.herokuapp.com/api';
    this.apiUrl = `${window.HPDiamondsAppURL}`;
    this.data = null;
    this.storeCurrency = "GBP";
    this.cartAttributes = JSON.parse(this.dataset.cartAttributes);

    /* Get required Dom Elements */
    this.nivodaForm = this.querySelector("#diamond_nivoda");
    this.nivodaFilters = this.nivodaForm.querySelectorAll("input[name], range-selector, select[name]");

    this.gridView = this.querySelector(".grid-view");
    this.listView = this.querySelector(".list-view");
    this.diamondSelected = this.querySelector(".diamond-selected");
    this.diamondList = this.querySelector(".diamond-choose-content");
    this.form = this.querySelector("form");
    this.exceptionalInputsName = ["advanced", "results-view", "load-more-items"];
    this.selectedId = null;
    this.imgPlaceholder = this.dataset.placeholder;
    this.loadingSvg = `<div><svg width="25px" height="25px" aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
      <img src='https://cdn.shopify.com/s/files/1/0643/2348/5937/files/regal-r-logo.png?v=1668501506' width='25' height='25' loading='lazy'/>
      </div>`;
    this.showHideMobileFilter = this.querySelector(".results-header__show-btn");
    this.mobileFilterContainer = this.querySelector(".results-view--left");
    this.controller = null;
    this.resultsBox = this.querySelector(".results");
    this.resultsError = this.querySelector(".results_error");
    this.resultsLoading = this.querySelector(".results_loading");
    this.itemsCount = this.querySelector(".items_count");
    this.resultsList = this.querySelector(".results-box");
    this.diamondTypes = document.querySelectorAll('input[name="labgrown"]');
    this.showHideMobileFilter.addEventListener("click", (e) => {
      this.mobileFilterContainer.classList.toggle("hide-mobile");
    });
    const parent = this;
    let params = new URLSearchParams(this.getDefaultSearchParams());
    this.querySelectorAll('[name="labgrown"]').forEach((diamondType) => diamondType.addEventListener("change", this.updateDiamondTypeCallback.bind(this)));
    const redirectedShape = params.get("shape")?.toUpperCase() || window.HP_tempShape?.toUpperCase() ||  this.dataset.tempShape?.toUpperCase();
    console.log("redirectedShape", redirectedShape);
    try {
      if (redirectedShape) {
        this.nivodaForm.querySelector("#nivoda_filter_shape").querySelector(`input[value=${redirectedShape}]`).checked = true;
      }
    } catch (error) {
      console.log(error);
    }
    this.limit = +this.form.querySelector('[name="limit"]').value;
    const popupTriggers = document.querySelectorAll(".filter-type-popup-trigger");
    popupTriggers.forEach((trigger) => {
      trigger.addEventListener("click", function () {
        this.nextElementSibling.style.display = "block";
      });
    });
  }

  connectedCallback() {
    this.fancyColorToggle = this.querySelectorAll(".filter-color-type input");
    this.whiteColorInput = this.querySelector(".filter-color-type #fancyColor-white");
    const sessionSearchParams = this.getDefaultSearchParams();
    const searchParams = Array.from(new URLSearchParams(sessionSearchParams).entries());
    let updateURLHash = true;
    const resettedKeys = [];
    // group all the search params so all values will be in one array
    const formData = searchParams.reduce((acc, [key, value]) => {
      if (Array.isArray(acc[key])) {
        acc[key].push(value);
      } else {
        acc[key] = [value];
      }
      return acc;
    }, {});
    // loop through the form and set the values
    Object.entries(formData).forEach(([key, value]) => {
      const inputs = Array.from(this.form.querySelectorAll(`[name="${key}"]`) || []);
      if (inputs.length == 0) return;
      // first reset the inputs
      inputs.forEach((input) => {
        if (input.type == "checkbox" || input.type == "radio") {
          input.checked = false;
        } else if (input.type == "text") {
          input.value = "";
        }
      });
      if (inputs[0].type == "checkbox" || inputs[0].type == "radio") {
        value.forEach((val) => {
          let inputValue = key === "shapes" ? val.toUpperCase() : val;
          const valInput = this.form.querySelector(`[name="${key}"][value="${inputValue}"]`);
          if (valInput) {
            valInput.checked = true;
          }
        });
      } else if (inputs[0].type == "select-one" || inputs[0].tagName == "SELECT") {
        const valInput = this.form.querySelector(`[name="${key}"]`);
        if (valInput) {
          valInput.value = value[0];
          //setTimeout(() => {
          valInput.dispatchEvent(new Event("change"));
          //}, 1);
        }
      } else {
        const valInput = this.form.querySelector(`[name="${key}"]`);
        if (valInput) {
          valInput.value = value;
        }
      }
    });
    const hasFancyColor = !!document.querySelector('input[name="fancyColor"]:checked');
    if (hasFancyColor) {
      document.querySelectorAll(".filter-item--color-white input").forEach((input) => {
        input.closest(".filter-item").classList.toggle("hide", hasFancyColor);
      });
      document.querySelectorAll(".filter-item--color-fancy input").forEach((input) => {
        input.closest(".filter-item").classList.toggle("hide", !hasFancyColor);
      });
    }
    this.updateDiamondTypeCallback();
    this.updateHeadingsForSelectedDiamondType();
    this.submit();
    this.addListers();
  }

  getDefaultSearchParams() {
    let existtingSearchParams = window.sessionStorage.getItem("diamondSearchParams");
    if (!existtingSearchParams) return "";
    const shape = new URLSearchParams(window.location.search).get("shapes");

    if (shape) {
      // remove existing shape and add new one
      existtingSearchParams = existtingSearchParams.replace(/shapes=[^&]+/, `shapes=${shape}`);
    }
    // check if url is natural-diamonds or lab-grown-diamonds
    if (window.location.pathname.includes("lab-grown-diamonds")) {
      existtingSearchParams = existtingSearchParams.replace(/labgrown=[^&]+/, `labgrown=true`);
    } else if (window.location.pathname.includes("natural-diamonds")) {
      existtingSearchParams = existtingSearchParams.replace(/labgrown=[^&]+/, `labgrown=false`);
    }

    window.sessionStorage.setItem("diamondSearchParams", existtingSearchParams);

    // remove the shape from the search params on the url
    window.history.replaceState({}, "", `${window.location.pathname}`);
    return existtingSearchParams;
  }
  addListers() {
    const loadMoreInfoBtn = this.querySelector(".dc-load-more");
    const certificateInput = this.form.querySelector('[name="certificate_numbers"]');
    loadMoreInfoBtn.addEventListener("click", this.handleLoadMore.bind(this, loadMoreInfoBtn));
    this.nivodaForm.addEventListener("submit", function (e) {
      e.preventDefault();
      this.submit();
    });

    if (certificateInput) {
      certificateInput.addEventListener("input", (e) => {
        if (this.getAttribute("data-last-value") == certificateInput.value) return;
        certificateInput.dispatchEvent(new Event("change"));
        this.setAttribute("data-last-value", certificateInput.value);
      });
    }

    const deboncesubmit = (event) => {
      const input = event.target; // Get the input element that triggered the event
      if (certificateInput && certificateInput == input && this.getAttribute("data-last-value") == certificateInput.value) return;

      if (input.classList.contains("filter-range-min")) {
        console.log("Input Value:", input.value);
        const maxValue = input.parentElement.parentElement.querySelector(".filter-range-max").value;
        if (parseInt(input.value) > parseInt(maxValue)) {
          input.value = maxValue;
        }
      } else if (input.classList.contains("filter-range-max")) {
        console.log("Input Value:", input.value);
        const minValue = input.parentElement.parentElement.querySelector(".filter-range-min").value;
        if (parseInt(input.value) < parseInt(minValue)) {
          input.value = minValue;
        }
      } else {
      }

      if (input && input.name != "results-view" && input.name != "advanced") {
        this.data = null;
        this.states.results = false;
      }

      if (input && input.name == "results-view") {
        this.handleView();
      }

      if (input && this.exceptionalInputsName.includes(input.name)) return;

      return debounce(this.submit.bind(this), 200)();
    };
    this.nivodaFilters.forEach((input) => input.addEventListener("change", deboncesubmit));
    this.nivodaForm.addEventListener("reset", (e) => {});
    this.fancyColorToggle.forEach((input) => {
      input.addEventListener("change", this.handleColorViewUpdate.bind(this));
    });
  }
  updateHeadingsForSelectedDiamondType() {
    const selectedDiamondType = document.querySelector('input[name="labgrown"]:checked');
    document.querySelector(".homepage-sections-wrapper h1").innerHTML = "Choose A Diamond";
    const headingWrapper = document.querySelector(".homepage-sections-wrapper h2");
    const descriptionWrapper = document.querySelector(".homepage-sections-wrapper .featured-row__subtext");
    if (selectedDiamondType.getAttribute("id") == "lab-grown") {
      headingWrapper.innerHTML = this.querySelector(".diamond-choose").dataset.labgrownTitle;
      descriptionWrapper.innerHTML = this.querySelector(".diamond-choose").dataset.labgrownContent;
    } else {
      headingWrapper.innerHTML = this.querySelector(".diamond-choose").dataset.naturalTitle;
      descriptionWrapper.innerHTML = this.querySelector(".diamond-choose").dataset.naturalContent;
    }
  }
  handleColorViewUpdate() {
    this.fancyColorToggle = this.querySelectorAll(".filter-color-type input");
    this.whiteColorInput = this.querySelector(".filter-color-type #fancyColor-white");
    if (!this.whiteColorInput) return;
    document.querySelectorAll(".filter-item--color-white input").forEach((input, index) => {
      input.checked = false;
      if (index < 3) input.checked = this.whiteColorInput.checked;
      input.closest(".filter-item").classList.toggle("hide", !this.whiteColorInput.checked);
    });
    document.querySelectorAll(".filter-item--color-fancy input").forEach((input, index) => {
      input.checked = false;
      if (index == 0) input.checked = !this.whiteColorInput.checked;
      input.closest(".filter-item").classList.toggle("hide", this.whiteColorInput.checked);
    });
    this.submit();
  }

  updateDiamondTypeCallback() {
    let params = new URLSearchParams(this.getDefaultSearchParams());
    this.updateHeadingsForSelectedDiamondType();
    const isLabgrown = this.querySelector("input#lab-grown").checked;
    this.updateHeadingsForSelectedDiamondType();
    if (isLabgrown) {
      params.set("labgrown", true);
      document.querySelector('input#natural[name="labgrown"]').removeAttribute("checked");
      document.querySelector('input#lab-grown[name="labgrown"]').checked = true;
      if (this.form.querySelector('[value="IGI"')) this.form.querySelector('[value="IGI"').checked = true;
      if (this.form.querySelector('[value="GIA"')) this.form.querySelector('[value="GIA"').checked = false;

      this.form.querySelector('[name="dollar_value--min"]').value = "500.00";
      this.form.querySelector('[name="dollar_value--max"]').value = "100000.00";
      this.form.querySelector('[name="dollar_value--min"]').dispatchEvent(
        new Event("change", {
          bubbles: true,
        })
      );
      this.form.querySelector('[name="dollar_value--max"]').dispatchEvent(new Event("change"));
    } else {
      params.set("labgrown", false);
      if (this.form.querySelector('[value="IGI"')) this.form.querySelector('[value="IGI"').checked = false;
      if (this.form.querySelector('[value="GIA"')) this.form.querySelector('[value="GIA"').checked = true;
      this.form.querySelector('[name="dollar_value--min"]').value = "1500.00";
      this.form.querySelector('[name="dollar_value--max"]').value = "1000000.00";
      this.form.querySelector('[name="dollar_value--min"]').dispatchEvent(
        new Event("change", {
          bubbles: true,
        })
      );
      this.form.querySelector('[name="dollar_value--max"]').dispatchEvent(new Event("change"));
    }
    // let updatedUrl = `${window.location.origin}${
    //   window.location.pathname
    // }?${params.toString()}${window.location.hash}`;
    // window.history.replaceState({}, "", updatedUrl);
    window.sessionStorage.setItem("diamondSearchParams", params.toString());
  }

  handleSingleInfo(product, data) {
    if (event.target.href) return;
    event.preventDefault();
    event.stopPropagation();
    const id = product.getAttribute("data-id") || product.dataset.id;

    if (this.handleView(id) == true) {
      return;
    }
    this.selectedId = id;
    window.location.href = `/pages/single-diamond/${id}`;
  }
  handleView(id = null) {
    if (this.querySelector(".diamond-selected__item")) {
      if (id == this.selectedId || id == null) {
        this.querySelector(".diamond-selected__item").remove();
        return true;
      }
    }
  }

  async submit(updateURLHash = true, resetContent = true) {
    let signal = null;

    let newStates = { ...this.states, loading: true };
    if (resetContent) {
      console.log("resetContent");
      Array.from(this.resultsList.children).forEach((child) => child.remove());
    }
    try {
      const t0 = performance.now();
      this.renderResults(newStates);
      if (this.controller) {
        this.controller.abort();
      }
      // Create a new AbortController for the new fetch request
      this.controller = new AbortController();
      signal = this.controller.signal || null;
      let fetching;
      console.log(this.form);
      const certificate_id = this.form.querySelector('[name="certificate_numbers"]').value;
      const url = certificate_id == "" ? `${this.apiUrl}/diamonds/` : `${this.apiUrl}/diamonds/:${certificate_id}`;
      window.is_certificate_id_only = certificate_id == "" ? false : true;
      console.log("serializedForm", JSON.stringify(this.serializeForm(this.form)));
      fetching = await fetch(`${url}`, {
        signal: signal,
        method: "POST", // or 'PUT'
        body: JSON.stringify(this.serializeForm(this.form)), // data can be `string` or {object}!
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (fetching) {
        const data = await fetching.json();
        console.log(data);
        this.data = data.results;
        if (this.data.items) {
          newStates = {
            ...this.states,
            results: true,
            loading: false,
            errors: false,
          };
        }
        if (this.data.errors) {
          newStates = {
            ...this.states,
            errors: true,
            loading: false,
            results: false,
          };
        }
        // end to trak perfoamnce
        const t1 = performance.now();
        console.log(`Call to doSomething took ${t1 - t0} milliseconds., and seconds: ${(t1 - t0) / 1000}`);
      }
      this.updateTotalCount();
      this.renderResults(newStates, this.data);
      this.controller = null;
    } catch (error) {
      console.log(error);
      if (error.name === "AbortError") {
        console.log("Fetch was aborted");
      } else {
        newStates = {
          ...this.states,
          errors: true,
          loading: false,
          results: false,
        };
      }
      this.controller = null;
      this.countController = null;
      this.renderResults(newStates, null);
    } finally {
      //console.log("finally");
      if (updateURLHash) {
        const searchParams = this.createSearchParams(this.form);
        this.updateURLHash(searchParams);
      }
    }
  }

  setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      this.submit(false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  updateURLHash(searchParams) {
    window.sessionStorage.setItem("diamondSearchParams", searchParams);
    // history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  handleLoadMore(btn = null) {
    this.updateOffsetInput();
    this.states.results = true;
    btn ? (btn.innerHTML = '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>') : null;
    btn.dataset.loading = "loading";
    this.submit(false, false);
  }

  updateOffsetInput() {
    const offset = this.form.querySelector('[name="offset"]');
    offset.value = parseInt(offset.value) + this.limit;
  }

  serializeForm(form) {
    const formData = new FormData(form);
    const data = {};
    formData.forEach((value, key) => {
      if (data[key]) {
        if (Array.isArray(data[key])) {
          data[key].push(value);
        } else {
          data[key] = [data[key], value];
        }
      } else {
        data[key] = value;
      }
    });
    console.log({ data });
    return data;
  }
  handleClosestOption(selectOptions, value) {
    let closestOption = Array.from(selectOptions.options).sort((a, b) => {
      return Math.abs(a.value - value) - Math.abs(b.value - value);
    })[0];
    return closestOption;
  }
  renderResults(states, data = this.data) {
    console.log(data);
    var size = 4;
    var arrayOfArrays = [];
    for (var i = 0; i < data?.items?.length; i += size) {
      arrayOfArrays.push(data.items.slice(i, i + size));
    }
    const { loading, errors, results } = states;
    if (loading) {
      this.toggleActiveClass(this.resultsLoading);
      //this.nivodaFilters.forEach((input) => input.setAttribute('disabled', 'disabled'));
    }
    if (!loading || (loading && results)) this.toggleHideClass(this.resultsLoading);
    if (!errors) this.toggleHideClass(this.resultsError);
    if (!results) this.toggleHideClass(this.resultsBox);
    if (results && !loading) {
      if (data.items.length == 0) {
        this.toggleActiveClass(this.resultsError);
      } else {
        this.toggleActiveClass(this.resultsBox);
        arrayOfArrays.map((row) => {
          const div = document.createElement("div");
          div.classList.add("result-div");
          row.map((item, index) => (div.innerHTML += this.renderItems(item, index + 1)));
          return this.resultsList.append(div);
        });

        let moreSingleInfoBtn = this.querySelectorAll(".result--product");
        let cardSelectedBtn = this.querySelectorAll(".card-selected-diamond");
        let cardMoreInfoBtn = this.querySelectorAll(".card-more-info-diamond");
        let listViewSelectedBtn = this.querySelectorAll(".result--list__data-view");

        moreSingleInfoBtn.forEach((product) => {
          product.addEventListener("click", this.handleSingleInfo.bind(this, product, data));
        });
        cardSelectedBtn.forEach((product) => {
          product.addEventListener("click", this.handleSingleDiamond.bind(this, product.dataset.id, data));
        });
        cardMoreInfoBtn.forEach((product) => {
          product.addEventListener("click", this.handleMoreInfoDiamond.bind(this, product.dataset.id, data));
        });
        listViewSelectedBtn.forEach((product) => {
          product.addEventListener("click", this.handleSingleDiamond.bind(this, product.dataset.id, data));
        });

        let loadMoreInfoBtn = this.querySelector(".dc-load-more");
        loadMoreInfoBtn.textContent = "Load more";
        delete loadMoreInfoBtn.dataset.loading;
        if (this.data.total_count <= this.limit) {
          this.toggleHideClass(loadMoreInfoBtn);
        } else {
          this.toggleActiveClass(loadMoreInfoBtn);
        }
      }
    }
  }
  async updateTotalCount() {
    let signal = null;

    if (this.countController) {
      this.countController.abort();
    }
    // Create a new AbortController for the new fetch request
    this.countController = new AbortController();
    signal = this.countController.signal || null;
    this.itemsCount.innerHTML = this.loadingSvg;
    console.log("this.data", this.data);
    if (window.is_certificate_id_only == false) {
      fetch(`${this.apiUrl}/diamonds/count`, {
        signal: signal,
        method: "POST", // or 'PUT'
        body: JSON.stringify(this.serializeForm(this.form)), // data can be `string` or {object}!
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(async (data) => {
          console.log("data", data);
          this.data.total_count = data.total_count;
          // format number to England format
          this.itemsCount.innerHTML = this.data.total_count.toLocaleString("en-GB");
          let loadMoreInfoBtn = this.querySelector(".dc-load-more");
          if (this.data.total_count <= this.limit) {
            this.toggleHideClass(loadMoreInfoBtn);
          } else {
            this.toggleActiveClass(loadMoreInfoBtn);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.countController = null;
        });
    } else {
      this.itemsCount.innerHTML = this.data.total_count;
    }
  }
  handleDimensions(length, width, depth) {
    // first turn it to Number and make if fixed to 2 deceimal
    length = Number(length).toFixed(2);
    width = Number(width).toFixed(2);
    depth = Number(depth).toFixed(2);
    // return
    return { length, width, depth };
  }
  renderItems(item, index) {

    //console.log("item", item);
    const { diamond, price, markup_price, GBP_markup_price } = item;
    const { id, certificate, image, video, supplierStockId, eyeClean } = diamond;
    const {
      length: length_,
      width: width_,
      depth: depth_,
      shape,
      carats,
      color,
      symmetry,
      cut,
      image: certImage,
      pdfUrl,
      polish,
      certNumber,
      lab,
      labgrown,
      labgrown_type,
      floInt,
      floCol,
      clarity,
      video: certVideo,
    } = certificate;
    const { IGI, STOCKID } = lab;
    const renderVideo = video ? video : certVideo ? certVideo : null;
    // console.log(length_, width_, depth_);
    const { length, width, depth } = this.handleDimensions(length_, width_, depth_);

    return `<li class="result--product" data-id = ${id}>
    <figure class="result--product__figure">
      <result-card-media class="media media--transparent media--square media--contain">
        <img
        src="${certImage ? certImage : window.placeholder_images[shape]}"
        class="${certImage ? "card-diamond-img" : "card-placeholder-img"}"
        alt="${shape ? shape : "NA"}"
        height="100"
        width="100"
        loading="lazy">
        ${
          renderVideo
            ? `<iframe width='500' loading="eager" height='500' frameborder='0' allow='accelerometer; autoplay;' src='${renderVideo.replace(
                "/500/500",
                ""
              )}' autoplay ></iframe>`
            : ""
        }
      </result-card-media>
      <div class="result-item__top-labels">
        ${lab == "GIA" ? `<span class="result-item__top-label result-item__top-label--lab-grown">${lab}</span>` : ""}
        ${labgrown == true ? '<span class="result-item__top-label result-item__top-label--lab-grown">Lab</span>' : ""}
        ${!!labgrown_type == true ? `<span class="result-item__top-label">${labgrown_type}</span>` : ""}
      </div>

    
      ${
        eyeClean == "100%"
          ? `
      <div class="result-item__bottom-labels">
      <span class="result-item__bottom-label result-item__bottom-label--lab-grown">Recommended</span>
      </div>`
          : ""
      }
      
    </figure>
    <span data-carats class="result--list__data"> ${carats ? carats + "ct" : "NA"} </span>
    <span data-color class="result--list__data"> ${color ? color : "NA"} </span>
    <span data-clarity class="result--list__data"> ${clarity ? clarity : "NA"} </span>
    <span data-polish class="result--list__data"> ${polish ? polish : "NA"} </span>
    <span data-symmetry class="result--list__data"> ${symmetry ? symmetry : "NA"} </span>
    <span data-cut class="result--list__data"> ${cut ? cut : "NA"} </span>
    <span data-floInt class="result--list__data"> ${floInt ? floInt : "NA"} </span>
    <span data-lab class="result--list__data"> ${lab ? lab : "NA"} </span>
    <span class="result--list__data">${GBP_markup_price ? wetheme.formatMoney(GBP_markup_price, wetheme.moneyFormat) : "NA"}</span>
    <a href="/pages/single-diamond/${id}" class="btn result--list__data result--list__data-view" data-id="${id}">Select</a>

    <div class="result--grid__info">
      <h3 class="result--product__title">
        <span data-shape> ${shape ? shape : "NA"} </span>
        <span data-carats> ${carats ? carats + "ct" : "NA"} </span>
        <span data-color> ${color ? color : "NA"} </span>
        <span data-clarity> ${clarity ? clarity : "NA"} </span>
        ${cut ? "<span data-cut>" + cut + "</span>" : ""}
        <span data-symmetry> ${symmetry ? symmetry : "NA"} </span>
        <span data-polish> ${polish ? polish : "NA"} </span>
        <span data-floInt> ${floInt ? floInt : "NA"} </span>
        <!-- <span data-floCol> ${floCol ? floCol : ""} </span> -->
      </h3>

      <span class="result--product__meta-info">
        <div><b>${lab}: </b> ${certNumber.replace("labgrownsolitaires", "")}</div>
        <div><b>Stock ID: </b> ${supplierStockId}</div>
      </span>

      <span class="result--product__meta-info">
        <div><span class="result--product__meta-info--bg-light">M:</span>  ${width} - ${length} x ${depth}</div>
        <div><span class="result--product__meta-info--bg-light">R:</span> ${(length / width).toFixed(2)}</div>
      </span>

      <span class="result--product__meta-info">
        <div><b>Total price</b></div>
        <div><h4 class="result--product__price">${GBP_markup_price ? wetheme.formatMoney(GBP_markup_price, wetheme.moneyFormat) : "NA"}</h4></div>
      </span>
      <div class="result--product__buttons">
          <a 
            href="#"
            id="add_to_ring_btn"
            data-is-complete="${this.cartAttributes.ring ? "true" : "false"}"
            class="btn card-selected-diamond" 
            data-id="${id}">SELECT</a>
          <a href="/pages/single-diamond/${id}" class="btn card-more-info-diamond" data-id="${id}">MORE INFO</a>
        </div> 
      </div>
    </div>
  </li>`;
  }

  toggleActiveClass(component) {
    component.classList.add("data-active");
    component.classList.remove("data-hide");
  }
  toggleHideClass(component) {
    component.classList.remove("data-active");
    component.classList.add("data-hide");
  }

  setCookie(name, value, hours = 1) {
    const expires = new Date(Date.now() + hours * 60 * 60 * 1000).toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + expires + "; path=/";
  }
  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }
  removeCookie(name) {
    setCookie(name, "", -1);
  }
  async handleSingleDiamond(itemId, data) {
    event.preventDefault();
    const btn = event.target;
    const item = data.items.find((item) => item.diamond.id === itemId);
    const { GBP_markup_price } = item;
    const { carats, shape, clarity, color, lab } = item.diamond.certificate;
    let customShape = shape.toLowerCase();
    customShape = customShape.charAt(0).toUpperCase() + customShape.slice(1);
    if (customShape.toLowerCase().includes("cushion")) {
      customShape = "Cushion";
    }
    const title = `${carats && carats + "ct"} ${shape && shape + " Diamond"}`;
    const fullRingTitle = `${carats && carats + " Carat | "}${shape.toLowerCase() && shape.toLowerCase() + " Shaped Diamond | "}${
      color && color + " Colour | "
    }${clarity && clarity + " Clarity"}`;
    const image = item.diamond.certificate.image || window.placeholder_images[shape.toUpperCase()];
    customShape = customShape.includes("Cushion") ? "Cushion" : customShape;
    const link = `/collections/engagement-rings-in-hatton-garden?filter.p.m.custom.shape=${customShape}&sort_by=best-selling&view=select-ring`;
    // add diamond id to cart attribute
    localStorage.setItem("selectedLab", lab);
    await fetch("/cart.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json;",
      },
      body: JSON.stringify({
        attributes: {
          tempShape: customShape.toLowerCase(),
          diamond: {
            id: itemId,
            title,
            price: GBP_markup_price,
            fullRingTitle,
            image,
            productHandle: "",
            shape: customShape,
          },
        },
      }),
    });
    console.log({ btn });
    if (btn.dataset.isComplete === "true") {
      window.location = "/pages/full-ring";
    } else {
      window.location = link;//"/collections/engagement-rings";
    }
  }

  handleMoreInfoDiamond(itemId, data) {
    event.preventDefault();
    const item = data.items.find((item) => item.diamond.id === itemId);
    localStorage.setItem("singleDiamond", JSON.stringify(item));
    window.location = `/pages/single-diamond/${itemId}`;
  }
}
customElements.define("design-your-engagement-ring", DesignYourEngagementRing);

class ResultCardMedia extends HTMLElement {
  constructor() {
    super();

    // call setFrameSize on window size change
    //window.addEventListener('resize', debounce(this.setFrameSize.bind(this), 500));
  }

  connectedCallback() {
    //this.setFrameSize();
  }

  setFrameSize() {
    console.log("framesiz");
    const iframe = this.querySelector("iframe");
    if (!iframe) return;
    const width = this.offsetWidth;
    const height = this.offsetHeight;
    const frameSize = Math.min(width, height);
    console.log(frameSize);
    const src = iframe.src;
    let remove_after = src.indexOf("video");
    let result = src.substring(0, remove_after);
    // repalce the 500 in the src with the frameSize
    iframe.src = `${result}video/${frameSize}/${frameSize}`;
  }
}

customElements.define("result-card-media", ResultCardMedia);
